export const globalStyles = {
  primaryColor: '#1f59bb',
  secondaryColor: 'rgba(53, 151, 245, 0.1)',
  pryBlueclr: '#12376d',
  secBlueclr: '#131b49',
  terBlueclr: '#30507f',
  brightBlueclr: '#0050af',
  pryBlackclr: '#18191f',
};
